import { useEffect } from 'react';
import { useAuth as useOidcAuth } from 'react-oidc-context';
import { Outlet, useNavigate } from 'react-router';
import { AppLayout } from 'softcat:components/app-layout.tsx';
import { Loading } from 'softcat:components/loading.tsx';
import { useAuth } from 'softcat:hooks/use-auth.ts';
import { useTerritory } from 'softcat:hooks/use-territory.ts';
import { ConfigService } from 'softcat:services/config.ts';
import { preload } from 'swr';

export const Root = () => {
    const { isAuthenticated } = useAuth();
    const oidcAuth = useOidcAuth();
    const navigate = useNavigate();
    const { activeTerritory } = useTerritory();

    useEffect(() => {
        if (isAuthenticated) {
            preload({ key: `${activeTerritory}-ConfigServiceFindAllConfigVersions` }, ConfigService.findAllConfigVersions);
            preload({ key: `${activeTerritory}-ConfigServiceFindAllEntitlements` }, ConfigService.findAllEntitlements);
            preload({ key: `${activeTerritory}-ConfigServiceFindAllPlatforms` }, ConfigService.findAllPlatforms);
        } else if (!oidcAuth.isLoading && !oidcAuth.isAuthenticated) {
            navigate('/login');
        }
    }, [activeTerritory, isAuthenticated, navigate, oidcAuth.isAuthenticated, oidcAuth.isLoading]);

    return isAuthenticated ? (
        <AppLayout>
            <Outlet />
        </AppLayout>
    ) : (
        <Loading />
    );
};
